var map = {
	".": 72,
	"./": 72,
	"./GraphQLLanguageService": 172,
	"./GraphQLLanguageService.js": 172,
	"./GraphQLLanguageService.js.flow": 640,
	"./autocompleteUtils": 109,
	"./autocompleteUtils.js": 109,
	"./autocompleteUtils.js.flow": 641,
	"./getAutocompleteSuggestions": 110,
	"./getAutocompleteSuggestions.js": 110,
	"./getAutocompleteSuggestions.js.flow": 642,
	"./getDefinition": 111,
	"./getDefinition.js": 111,
	"./getDefinition.js.flow": 643,
	"./getDiagnostics": 113,
	"./getDiagnostics.js": 113,
	"./getDiagnostics.js.flow": 644,
	"./getOutline": 171,
	"./getOutline.js": 171,
	"./getOutline.js.flow": 645,
	"./index": 72,
	"./index.js": 72,
	"./index.js.flow": 646
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-language-service-interface/dist ^.*$
// module id = 326
// module chunks = 0